import React from "react";

export const SolicitudContext = React.createContext();